'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Snackbar = _interopDefault(require('@material-ui/core/Snackbar'));
var AlertBanner = require('../../AlertBanner/AlertBanner.js');

var DEFAULT_AUTOHIDE = 2500;
var AlertSnackBar = function (props) {
    var severity = props.severity, children = props.children, onClose = props.onClose, autoHideDuration = props.autoHideDuration;
    var _a = React__default.useState(true), open = _a[0], setOpen = _a[1];
    var autoHideTime = null;
    var closeHandler = function () {
        setOpen(false);
        if (onClose)
            onClose();
    };
    var snackBarCloseHandler = function (event, reason) {
        if (reason === 'clickaway')
            return;
        closeHandler();
    };
    if (severity === 'success') {
        autoHideTime = autoHideDuration || DEFAULT_AUTOHIDE;
    }
    return (React__default.createElement(Snackbar, { open: open, onClose: snackBarCloseHandler, autoHideDuration: autoHideTime },
        React__default.createElement(AlertBanner, { severity: severity, withClose: true, onClose: closeHandler }, children)));
};

module.exports = AlertSnackBar;
